import { render } from "./Lpns.vue?vue&type=template&id=b2eb65e2"
import script from "./Lpns.vue?vue&type=script&lang=js"
export * from "./Lpns.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__